

import React from 'react';


import { relationshipsText } from './../../text/relationships-text.js';


import { motion } from 'framer-motion';



const RelationshipsTab = ({ opeLevel, conLevel, extLevel, agrLevel, staLevel, opeTitle, opeLogo, conTitle, conLogo, agrTitle,
    agrLogo, extTitle, extLogo, staTitle, staLogo }) => {



    let opeText1;
    let opeText2;
   

    let conText1;
    let conText2;
  

    let extText1;
    let extText2;


    let agrText1;
    let agrText2;


    let staText1;
    let staText2;

    //console.log("opelevel" + opeLevel);


    if (opeLevel > 4) {
        opeText1 = relationshipsText.opeText1;
        opeText2 = relationshipsText.opeText2;

    }
    else if (opeLevel == 4) {
        opeText1 = relationshipsText.opeCloText;
    }
    else {
        opeText1 = relationshipsText.cloText1;
        opeText2 = relationshipsText.cloText2;

    }

    if (conLevel > 4) {
        conText1 = relationshipsText.conText1;
        conText2 = relationshipsText.conText2;
 
    }
    else if (conLevel == 4) {
        conText1 = relationshipsText.conUncText;
    }
    else {
        conText1 = relationshipsText.conText1;
        conText2 = relationshipsText.conText2;

    }

    if (extLevel > 4) {
        extText1 = relationshipsText.extText1;
        extText2 = relationshipsText.extText2;
 
    }
    else if (extLevel == 4) {
        extText1 = relationshipsText.extIntText;
    }
    else {
        extText1 = relationshipsText.intText1;
        extText2 = relationshipsText.intText2;
 
    }

    if (agrLevel > 4) {
        agrText1 = relationshipsText.agrText1;
        agrText2 = relationshipsText.agrText2;


    }
    else if (agrLevel == 4) {
        agrText1 = relationshipsText.agrDisText;
    }
    else {
        agrText1 = relationshipsText.disText1;
        agrText2 = relationshipsText.disText2;


    }

    if (staLevel > 4) {
        staText1 = relationshipsText.staText1;
        staText2 = relationshipsText.staText2;

    }
    else if (opeLevel == 4) {
        staText1 = relationshipsText.staNeuText;
    }
    else {
        staText1 = relationshipsText.neuText1;
        staText2 = relationshipsText.neuText2;


    }

    return (


        <motion.div className="result"
            initial={{ opacity: 0, y: -10 }}
            animate={
                { opacity: 1, y: 0, transition: { delay: 0.3 } }}
        >
            <>
                <div>
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={opeLogo} alt="logo" />
                        <div>
                            {opeTitle}
                        </div>
                    </h1>

                    <p> {opeText1} </p>

                    < div className="vertical-spacer" />


                    <p> {opeText2} </p>
                    < div className="vertical-spacer" />
                    <hr />
                </div>
                <div>
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={conLogo} alt="logo" />
                        <div>
                            {conTitle}
                        </div>
                    </h1>

                    <p> {conText1} </p>

                    < div className="vertical-spacer" />


                    <p> {conText2} </p>

                    < div className="vertical-spacer" />
                    <hr />
                </div>
                <div>
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={extLogo} alt="logo" />
                        <div>
                            {extTitle}
                        </div>
                    </h1>
                    <p> {extText1} </p>

                    < div className="vertical-spacer" />


                    <p> {extText2} </p>
                    < div className="vertical-spacer" />

                    <hr />

                </div>
                <div>
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={agrLogo} alt="logo" />
                        <div>
                            {agrTitle}
                        </div>
                    </h1>

                    <p> {agrText1} </p>

                    < div className="vertical-spacer" />


                    <p> {agrText2} </p>


                    < div className="vertical-spacer" />
                    <hr />
                </div>
                <div>
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={staLogo} alt="logo" />
                        <div>
                            {staTitle}
                        </div>
                    </h1>

                    <p> {staText1} </p>

                    < div className="vertical-spacer" />


                    <p> {staText2} </p>
                    < div className="vertical-spacer" />

                    <hr />
                </div>
            </>

        </motion.div>
    );
}

export default RelationshipsTab;